module.exports = "textarea {\n  min-height: 100px; }\n"